"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var drive_types_1 = require("../../common/types/drive.types");
var angular_1 = __importDefault(require("angular"));
var StudentDrivesController = /** @class */ (function () {
    function StudentDrivesController(student, CalendarModel, DrivesFilterService, $state) {
        this.$state = $state;
        this.loading = false;
        this.loadError = false;
        this.unsignedLessons = [];
        this.drives = [];
        this.user = student;
        // @TODO: angular.fromJson is probably not necessary here
        this.address = angular_1.default.fromJson(this.user.school.address);
        this.calendarItems = [];
        this.CalendarModel = CalendarModel;
        this.zones = [];
        this.noSessionsAvailable = false;
        this.calendarFlag = "";
        this.roadmap = null;
        this.filterOptions = {
            days: "all",
            times: "all",
        };
        this.applyingFilter = false;
        DrivesFilterService.clearFilterOptions();
        this.loadCalendar();
    }
    StudentDrivesController.prototype.requiresLessonSignatures = function () {
        return this.calendarFlag === "unsigned_previous_lessons";
    };
    StudentDrivesController.prototype.applyFilter = function () {
        if (!this.loading) {
            this.loadCalendar();
        }
    };
    StudentDrivesController.prototype.loadCalendar = function () {
        var _this = this;
        this.loading = true;
        this.applyingFilter = true;
        this.loadError = false;
        var now = new Date();
        this.CalendarModel.getStudentCalendar({
            month: now.getMonth() + 1,
            year: now.getFullYear(),
            days: this.filterOptions.days,
            times: this.filterOptions.times,
        })
            .then(function (response) { return _this.handleCalendar(response); })
            .catch(function () {
            _this.loadError = true;
        })
            .finally(function () {
            _this.loading = false;
            _this.applyingFilter = false;
        });
    };
    StudentDrivesController.prototype.handleCalendar = function (response) {
        var _this = this;
        this.calendarFlag = response.data.flag;
        this.roadmap = response.data.roadmap || null;
        this.unsignedLessons = (response.data.unsigned_lessons || []).map(function (lesson) { return (__assign(__assign({}, lesson), { url: _this.$state.href("drivecoach.student.drives.view", {
                id: lesson.id,
            }) })); });
        this.noSessionsAvailable = response.data.drives.length === 0;
        this.calendarItems = response.data.drives.map(function (drive) {
            drive.date = drive.drive_date;
            drive.typeDisplay =
                typeof drive.type === "string" ? drive.type : drive.type.name;
            drive.type = "Drive Session";
            if (drive.private === "Y" && drive.observation === false) {
                drive.typeDisplay = drive.typeDisplay + " (Hidden)";
            }
            if (drive.private === "Y" && drive.observation === true) {
                drive.typeDisplay = drive.typeDisplay + " (Observation - Hidden)";
            }
            if (drive.observation === true && drive.private === "N") {
                drive.typeDisplay = drive.typeDisplay + " (Observation)";
            }
            Object.assign(drive, (0, drive_types_1.formatDriveForDisplay)(drive));
            drive.timestamp = (0, time_1.getUnixTimestamp)(new Date(drive.drive_date + " " + drive.start_time));
            // @TODO: angular.fromJson is probably not necessary here
            drive.location = angular_1.default.fromJson(drive.location);
            var datetime = new Date(drive.date + " " + drive.start_time);
            drive.styling = _this.CalendarModel.getStylingForDriveCard(drive);
            drive.actionRequired =
                drive.hasUngradedReportcards === true &&
                    drive.status === "Taken" &&
                    (0, time_1.isBefore)(datetime, new Date());
            return drive;
        });
    };
    StudentDrivesController.prototype.userHasFees = function () {
        return this.user.status === "Inactive - Fee";
    };
    StudentDrivesController.prototype.pastStartDate = function () {
        return (0, time_1.isBefore)(new Date(this.user.usermeta.start_date), new Date());
    };
    StudentDrivesController.prototype.studentNeedsToPurchaseSessions = function () {
        var _a, _b;
        var timePurchased = (_a = this.user.timepurchased) !== null && _a !== void 0 ? _a : 0;
        var timeScheduled = (_b = this.user.timescheduled) !== null && _b !== void 0 ? _b : 0;
        var studentHasNoHours = timeScheduled >= timePurchased;
        return (this.calendarItems.length === 0 &&
            studentHasNoHours &&
            this.userHasFees() === false);
    };
    return StudentDrivesController;
}());
StudentDrivesController.$inject = [
    "student",
    "CalendarModel",
    "DrivesFilterService",
    "$state",
];
exports.default = StudentDrivesController;
